/**
 *
 * Demos:
 *
 * - [Tabs](https://ui-packages.isbuildingluma.com/ui-core/react-tabs/)
 *
 * API:
 *
 * - [Tabs API](https://ui-packages.isbuildingluma.com/ui-core/api/tabs/)
 * - inherits [MuiTabs API](https://mui.com/material-ui/api/tabs/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Design-System-Playground?type=design&node-id=304-22913&t=wWEUIWiseZ4sbDj9-0)
 */
const MuiTabs = {
  styleOverrides: {
    root: {
      minHeight: 40
    },
    indicator: {
      display: 'none'
    }
  }
};
export const MuiTab = {
  defaultProps: {
    iconPosition: 'start'
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
      height: 40,
      minHeight: 40,
      borderRadius: 4,
      '& .MuiTab-iconWrapper': {
        marginRight: theme.spacing(1.25)
      },
      '&:hover': {
        backgroundColor: theme.palette.background.default,
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.background.default
        },
        color: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.primary.main
        }
      },
      '&:active': {
        backgroundColor: theme.palette.primary[300],
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.primary[300]
        },
        '& svg': {
          color: theme.palette.primary.main
        }
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary[200],
        color: theme.palette.text.primary,
        '& .MuiBadge-dot': {
          outlineColor: theme.palette.primary[200]
        },
        '& svg': {
          color: theme.palette.primary.main
        }
      }
    })
  }
};
export default MuiTabs;